import { useEffect, useState, useRef, useCallback } from "react";
import { connect, useSelector } from "react-redux";

import { NavLink, useParams, useLocation, Link } from "react-router-dom";

import Dropzone, {
  IDropzoneProps,
  ILayoutProps,
} from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { Image, Shimmer } from "react-shimmer";
import { Formik, Form, Field, FormikProps, ErrorMessage } from "formik";
import * as Yup from "yup";
import Modal from "react-bootstrap/Modal";
import { history } from "../../../shared/_helpers/history";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import BackIco from "../../../assets/back.svg";
import { WithContext as ReactTags } from "react-tag-input";
import { InAppTemplate } from "../../../shared/templates/inapp";
import {
  allowNumbersOnly,
  numberWithCommas,
  decimalNumber,
} from "../../../shared/utils";
import CaretDn from "../../../assets/caret-dn.svg";
import AddImg from "../../../assets/add-img.svg";
import UploadIcon from "../../../assets/icons/upload.svg";
import TrashIcon from "../../../assets/icons/ic_delete.svg";
import DoneIcon from "../../../assets/icons/done.svg";
import RemoveIcon from "../../../assets/icons/remove.svg";
import SearchIco from "../../../assets/icons/search.svg";
import LeftArrow from "../../../assets/icons/left-arrow.png";
import TickIco from "../../../assets/icons/tick.svg";
import "../index.scss";
import { AlertMsg } from "../../../shared/components/alert-msg";
import { LoadingItem } from "../../../shared/components/loading";
import { appActions } from "../../../redux/actions/in-app";

import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ProductImagePopUp from "../../../views/app/products/ProductImagePopup";
import ProductVarianceModal, {
  Variant,
} from "../../../views/app/products/ProductVarianceModal";
const sizeofFetch = 8;

const getMetadata = async ({ pageProps, payload }: any) => {
  await pageProps.getMetadataAction(payload);
};

const addNewProduct = async ({ pageProps, payload }: any) => {
  await pageProps.createProductAction(payload);
};

const uploadProductImage = async ({ pageProps, payload, otherNames }: any) => {
  await pageProps.uploadProductImageAction(payload, otherNames);
};

const getImagesGallery = async ({ pageProps, payload }: any) => {
  await pageProps.getImageGalleryAction(payload, false);
};

const getMoreImages = async ({ pageProps, payload }: any) => {
  await pageProps.getImageGalleryAction(payload, true);
};

const MainHeader = () => {
  return (
    <div className="product-info-header">
      <div
        className="left-nav"
        onClick={() => history.replace("/app/my-products")}
      >
        {" "}
        <img src={LeftArrow} alt="" />{" "}
      </div>
      <div className="other-item-wrap">
        <div className="heading-text">New Product</div>
        <div className="heading-msg">
          Kindly add a new product to your store by filling out the necessary
          information below
        </div>
      </div>
    </div>
  );
};

const InAppContent = ({ pageProps }: any) => {
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [showCatError, setShowCatError] = useState(false);
  const [selectedImagesStore, setSelectedImagesStore] = useState<any[]>([]);
  const [selecteCatsStore, setSelecteCatsStore] = useState<any[]>([]);
  const [catListItems, setCatListItems] = useState<any>();

  const [allCatsList, setAllCatsList] = useState<any[]>([]);
  const [allCatsSelected, setAllCatsSelected] = useState<any[]>([]);
  const [startDate, onStartChange] = useState<any>();
  const [endDate, onEndChange] = useState<any>();
  const [isTaxableOption, setIsTaxable] = useState(false);
  const [isDiscountMore, setIsDiscountMore] = useState(false);
  const [uploadImagesData, setUploadImagesData] = useState<any[]>([]);

  // New product features state
  const [wholesaleProduct, setWholesaleProduct] = useState<boolean>(false);
  const [minimumOrderQuantity, setMinimumOrderQuantity] = useState<string>("");
  const [availability, setAvailability] = useState<string>("0");
  const [addVariant, setAddVariant] = useState<boolean>(false);
  const [variants, setVariants] = useState<Variant[]>([]);
  const [eligibleForReturn, setEligibleForReturn] = useState<boolean>(false);
  const [eligibleForReturnOption, setEligibleForReturnOption] =
    useState<string>("0");
  const [showAddEditVariantPopup, setShowAddEditVariantPopup] =
    useState<boolean>(false);
  const [editingVariantIndex, setEditingVariantIndex] = useState<number | null>(
    null,
  );
  const [variantToEdit, setVariantToEdit] = useState<Variant | null>(null);

  // const otherData =

  const { storeId } = useParams();
  const { state } = useLocation();
  let imagesChosen: any = [];

  const modules = {
    toolbar: [
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["image", "link"],
    ],
  };

  const formats = [
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "align",
    "list",
    "bullet",
    "image",
    "link",
  ];

  // console.log("state is =>", state, storeId)

  useEffect(() => {
    setShowCatError(false);
    setAllCatsSelected([]);

    getMetadata({
      pageProps,
      // payload: "CLEAR"
    }).then(() => {});

    getImagesGallery({
      pageProps,
      payload: "CLEAR",
    });
    addNewProduct({
      pageProps,
      payload: "CLEAR",
    });
  }, []);

  useEffect(() => {
    if (
      pageProps.getProductMetaDataRequest.request_status ===
      "GET_PRODUCT_META_SUCCESS"
    ) {
      setSelectedImagesStore([]);
      let catsData: any[] =
        pageProps.getProductMetaDataRequest.request_data.response.categories;

      let catFormated: any[] = catsData.map((each: any) => {
        return { label: each?.name, value: each?.name };
      });

      // console.log("catsData is ", catFormated)
      setAllCatsList(catFormated);
    }
  }, [pageProps?.getProductMetaDataRequest?.request_status]);

  useEffect(() => {
    if (!showImagesModal) {
      setSelectedImagesStore(uploadImagesData);
    }
  }, [showImagesModal]);

  const removeProductImage = (url: string) => {
    const imagesBatch = selectedImagesStore.filter(
      (itemData: any) => itemData.url !== url,
    );

    setSelectedImagesStore(imagesBatch);

    setUploadImagesData(
      imagesBatch.slice(0, 1), // keep max 1 image
    );
  };

  const hideProductImgModal = () => setShowImagesModal(false);

  let detailsValidationSchema = Yup.object().shape({
    productName: Yup.string().required("Required"),
    productPrice: Yup.string().required("Required"),
    productSize: Yup.string().required("Required"),
    productQty: Yup.string().required("Required"),
    productUnit: Yup.string().required("Required"),
    productTags: Yup.string(),
    addDiscount: Yup.boolean(),
    productDiscountPercent: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountPrice: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountStart: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountEnd: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    wholesaleProduct: Yup.boolean(),
    minimumOrderQuantity: Yup.number().when("wholesaleProduct", {
      is: (wholesaleProduct: boolean) => wholesaleProduct === true,
      then: Yup.number().required(),
    }),
    available: Yup.string().matches(/^(1|2|0)$/),
    addVariant: Yup.boolean(),
    eligibleForReturn: Yup.boolean(),
    eligibleForReturnOption: Yup.string().when("eligibleForReturn", {
      is: (eligibleForReturn: boolean) => eligibleForReturn === true,
      then: Yup.string().matches(/^(1|2|0)$/),
    }),

    productDesc: Yup.string().required("Required"),
  });

  let initialValues: any = {
    productName: "",
    productPrice: "",
    productSize: "",
    productQty: "",
    productUnit: "",
    productStatus: "",
    productDesc: "",
    productDiscountPercent: "",
    productDiscountPrice: "",
    productDiscountStart: "",
    productDiscountEnd: "",
    startDate: "",
    endDate: "",
    addDiscount: false,
    wholesaleProduct: false,
    minimumOrderQuantity: "",
    available: "0",
    addVariant: false,
    eligibleForReturn: false,
    eligibleForReturnOption: "0",
  };

  // console.log("selectedImagesStore", selectedImagesStore)

  return (
    <div className="inapp-content">
      <div className="page-content form-page">
        {/* {showImagesModal && <ProductImagePop />} */}
        {showImagesModal && (
          <ProductImagePopUp
            pageProps={pageProps}
            showImagesModal={showImagesModal}
            catListItems={catListItems}
            hideProductImgModal={hideProductImgModal}
            setUploadImagesData={setUploadImagesData}
          />
        )}

        {pageProps.getProductMetaDataRequest.request_status ===
          "GET_PRODUCT_META_SUCCESS" &&
          allCatsList.length >= 1 && (
            <div className="product-form">
              <div className="form_top">
                <div className="report_head_wrap">
                  <div className="report_head_left">
                    <div className="report_heading">
                      <img className="back_ico" src={BackIco} alt="" />{" "}
                      <span className="head_txt">Add a new product</span>{" "}
                    </div>
                  </div>
                  <div className="report_head_right">
                    <div className="product_options">
                      <NavLink end className={"active-nav"} to="#">
                        <div className="table_nav_item">Single Product</div>
                      </NavLink>
                      <Link
                        state={{
                          storeData: { storeName: state?.storeData?.storeName },
                        }}
                        className="head_cta_link"
                        to={`/app/stores/${storeId}/products/create-bulk`}
                      >
                        <div className="table_nav_item">Bulk Upload</div>
                      </Link>
                      {/* <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/products/create-new/bulk">
                                            <div className="table_nav_item">Bulk Product</div>
                                        </NavLink> */}
                    </div>
                  </div>
                </div>
              </div>
              <Formik
                initialValues={initialValues}
                validationSchema={detailsValidationSchema}
                onSubmit={(values: any, actions) => {
                  let loggedAccountInfo: any =
                    localStorage.getItem("mamiVendorXAuth") || "{}";
                  loggedAccountInfo = JSON.parse(loggedAccountInfo);

                  let urlsList = selectedImagesStore.map((img: any) => img.url);

                  let otherNamesList = selectedImagesStore.map((names: any) => {
                    let nameList: any[];

                    if (names?.othernames) {
                      nameList = names.othernames.map(
                        (eachName: any) => eachName,
                      );
                      return nameList.toString();
                    }
                    if (names?.otherNames) {
                      nameList = names.otherNames.map(
                        (eachName: any) => eachName,
                      );
                      return nameList.toString();
                    }
                  });
                  otherNamesList = otherNamesList.filter(
                    (element: any, index: any) => {
                      return otherNamesList.indexOf(element) === index;
                    },
                  );
                  otherNamesList = otherNamesList.filter(function (el: any) {
                    return (
                      el != null &&
                      el != "" &&
                      el != undefined &&
                      el != "undefined"
                    );
                  });

                  if (allCatsSelected.length === 0) {
                    setShowCatError(true);
                  }
                  if (allCatsSelected.length >= 1 && urlsList.length >= 1) {
                    setShowCatError(false);
                    let chosenCats = allCatsSelected.map(
                      (cat: any) => cat.value,
                    );
                    let formattedStart: any, formattedEnd: any;
                    if (startDate && endDate) {
                      formattedStart = new Date(startDate.toISOString());
                      formattedStart.setDate(formattedStart.getDate() + 1);
                      formattedStart = formattedStart.toISOString();

                      formattedEnd = new Date(endDate.toISOString());
                      formattedEnd.setDate(formattedEnd.getDate() + 1);
                      formattedEnd = formattedEnd.toISOString();
                    }

                    let payload = {
                      storeId: storeId,
                      name: values.productName.trim(),
                      categories: [...chosenCats],
                      urls: [...urlsList],
                      otherNames: [...otherNamesList],
                      description: values.productDesc.trim(),
                      sizePerUnit: parseFloat(
                        values.productSize.replace(/,/g, ""),
                      ),
                      availableQuantity: parseInt(values.productQty),
                      unitOfMeasureId: parseInt(values.productUnit),
                      price:
                        addVariant && variants.length > 0
                          ? undefined
                          : {
                              amount: parseFloat(
                                values.productPrice.replace(/,/g, ""),
                              ),
                            },
                      productType: addVariant && variants.length > 0 ? 1 : 0,

                      // productDiscountPercent: !productInfo?.discountPrice ? "" : exisitingPerCentOffer,
                      isTaxable: isTaxableOption,
                      discountPrice: values.addDiscount
                        ? {
                            amount: parseFloat(
                              values.productDiscountPrice.replace(/,/g, ""),
                            ),
                            startDate: formattedStart,
                            endDate: formattedEnd,
                          }
                        : null,
                      // New fields
                      // isWholesale: values.wholesaleProduct,
                      // minimumOrderQuantity:
                      //   values.wholesaleProduct && values.minimumOrderQuantity
                      //     ? parseInt(values.minimumOrderQuantity)
                      //     : undefined,
                      // availability:
                      //   values.available !== "0" ? values.available : undefined,
                      // isReturnable: values.eligibleForReturn,
                      // returnPeriod:
                      //   values.eligibleForReturn &&
                      //   values.eligibleForReturnOption !== "0"
                      //     ? values.eligibleForReturnOption
                      //     : undefined,
                      variants:
                        addVariant && variants.length > 0
                          ? variants.map((v: any) => ({
                              price: {
                                amount:
                                  typeof v.price === "object" && v.price
                                    ? v.price.amount
                                    : v.price
                                      ? parseFloat(
                                          v.price.toString().replace(/,/g, ""),
                                        )
                                      : 0,
                              },
                              discountPrice:
                                v.addDiscount && v.discountPrice
                                  ? {
                                      amount: parseFloat(
                                        v.discountPrice
                                          .toString()
                                          .replace(/,/g, ""),
                                      ),
                                      startDate: v.discountStartDate,
                                      endDate: v.discountEndDate,
                                      dueDate: v.discountEndDate,
                                    }
                                  : null,
                              availableQuantity: parseInt(v.stockQuantity) || 0,
                              attributeValues: [
                                {
                                  attributeName: v.category,
                                  value: v.value,
                                },
                              ],
                              urls: v.images?.map((img: any) => img.url) || [],
                              isActive: true,
                            }))
                          : undefined,
                    };

                    // console.log("startDate=>", startDate.toISOString())
                    // console.log("startDate=>", startDate)
                    // console.log("endate=>", endDate.toISOString())
                    // console.log("payload=>", payload)
                    // console.log("allCatsSelected=>", allCatsSelected)

                    addNewProduct({ pageProps, payload });
                  }
                }}
              >
                {(props: FormikProps<any>) => {
                  const {
                    values,
                    touched,
                    errors,
                    setFieldTouched,
                    handleChange,
                    setFieldValue,
                  } = props;
                  return (
                    <Form>
                      <div className="form-wrap">
                        <div className="right-product-form">
                          <div className="product-images-container">
                            <div
                              className={
                                selectedImagesStore.length >= 1
                                  ? "image-control"
                                  : "image-control full"
                              }
                            >
                              <div className="images-label">Product image</div>
                              <div
                                className="product-images"
                                onClick={() => {
                                  let allCatData: any = [];
                                  pageProps.getProductMetaDataRequest.request_data.response.categories.forEach(
                                    (eachCat: any) => {
                                      allCatData.push({
                                        value: eachCat.name,
                                        label: eachCat.name,
                                      });
                                    },
                                  );
                                  imagesChosen.length = 1;
                                  setCatListItems(allCatData);
                                  let payload = `page=1&size=${sizeofFetch}`;
                                  getImagesGallery({ pageProps, payload });
                                  // uploadProductImage({ pageProps, payload: "CLEAR" })
                                  setShowImagesModal(true);
                                }}
                              >
                                <div className="upload-wrap-content">
                                  <img src={AddImg} alt="" />
                                  <div className="upload-txt">
                                    Check <span>MamiMarkets Gallery</span> or{" "}
                                    <span>Upload from your device</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {selectedImagesStore.length >= 1 && (
                              <div className="all-images-chosen">
                                {selectedImagesStore.map(
                                  (eachImage: any, index: any) => {
                                    return (
                                      <div
                                        className="product-image-wrap"
                                        key={index}
                                      >
                                        <div className="image-actions">
                                          <div className="select-cover">
                                            <input
                                              type="radio"
                                              name="cover-image-select"
                                            />
                                          </div>
                                          <div
                                            className="deleteicon"
                                            onClick={() =>
                                              removeProductImage(eachImage.url)
                                            }
                                          >
                                            <img
                                              src={TrashIcon}
                                              alt=""
                                              className=""
                                            />
                                          </div>
                                        </div>

                                        <div
                                          className="product-image-item"
                                          key={index}
                                        >
                                          <img src={eachImage.url} alt="" />
                                        </div>
                                      </div>
                                    );
                                  },
                                )}
                              </div>
                            )}
                          </div>
                          <div className="uploads-msg">
                            Ensure you use high-quality images that clearly
                            showcase the product. Also note that pictures must
                            be in 450 x 450 dimension. Max file size of 5mb.
                          </div>
                          <div className="form-group">
                            <div className="tax-label">
                              Is this product taxable?{" "}
                              <span>Learn more</span>{" "}
                            </div>
                            <div className="all_options">
                              <div className="an_option">
                                <span
                                  className={` custom_radio  ${isTaxableOption ? "selected_option" : ""}`}
                                >
                                  <input
                                    onChange={(e) => setIsTaxable(true)}
                                    name="check_taxable"
                                    type="radio"
                                    id="isTaxable"
                                    value="isTaxable"
                                  />
                                </span>
                                <label htmlFor="isTaxable">
                                  <span>Yes</span>
                                </label>
                              </div>
                              <div className="an_option">
                                <span
                                  className={`custom_radio ${!isTaxableOption ? "selected_option" : ""}`}
                                >
                                  <input
                                    onChange={(e) => setIsTaxable(false)}
                                    name="check_taxable"
                                    type="radio"
                                    id="notTaxable"
                                    value="notTaxable"
                                  />
                                </span>
                                <label htmlFor="notTaxable">
                                  <span>No</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="add-discount-wrap">
                            <Field
                              onChange={handleChange}
                              type="checkbox"
                              name="addDiscount"
                              id="addDiscount"
                            />
                            <label htmlFor="addDiscount">Add a discount</label>
                          </div>
                          {values.addDiscount === true && (
                            <div className="discount-wrap">
                              <div className="two-sided">
                                <div className="form-group">
                                  <div
                                    className={
                                      errors.productDiscountPercent &&
                                      touched.productDiscountPercent
                                        ? "invalid-input-wrap "
                                        : ""
                                    }
                                  >
                                    <label htmlFor="productDiscountPercent">
                                      Discount %
                                      {values.productPrice && (
                                        <ErrorMessage
                                          name="productDiscountPercent"
                                          className="form-input-error"
                                          component="span"
                                        />
                                      )}
                                      {!values.productPrice && (
                                        <span className="price-info-txt">
                                          (Enter original price)
                                        </span>
                                      )}
                                    </label>

                                    <Field
                                      // value={values.productDiscountPercent}
                                      disabled={!values.productPrice}
                                      value={allowNumbersOnly(
                                        values.productDiscountPercent,
                                        3,
                                      )}
                                      name="productDiscountPercent"
                                      type="text"
                                      placeholder="Discount %"
                                      // onChange={handleChange}
                                      onChange={(e: any) => {
                                        let valueSet: any = numberWithCommas(
                                          e.target.value,
                                        );

                                        if (
                                          parseFloat(valueSet) <= 100 ||
                                          e.target.value === ""
                                        ) {
                                          setFieldTouched(
                                            "productDiscountPercent",
                                            true,
                                            true,
                                          );
                                          setFieldValue(
                                            "productDiscountPercent",
                                            valueSet,
                                          );

                                          let originalPrice: any = parseFloat(
                                            values.productPrice.replace(
                                              /,/g,
                                              "",
                                            ),
                                          );
                                          valueSet = valueSet.replace(/,/g, "");

                                          let newProductPrice: any =
                                            (parseFloat(valueSet) / 100) *
                                            parseFloat(originalPrice);
                                          newProductPrice =
                                            parseFloat(originalPrice) -
                                            newProductPrice;
                                          newProductPrice = Number.parseFloat(
                                            newProductPrice.toString(),
                                          ).toFixed(2);

                                          setFieldValue(
                                            "productDiscountPrice",
                                            newProductPrice.toString(),
                                          );
                                        }
                                      }}
                                      className={`input-wrap inapp-input ${
                                        errors.productDiscountPercent &&
                                        touched.productDiscountPercent
                                          ? "is-invalid-input "
                                          : !errors.productDiscountPercent &&
                                              values.productDiscountPercent !==
                                                ""
                                            ? "valid-input"
                                            : ""
                                      }`}
                                    ></Field>
                                  </div>
                                </div>
                                <div className="form-group">
                                  <div
                                    className={
                                      errors.productDiscountPrice &&
                                      touched.productDiscountPrice
                                        ? "invalid-input-wrap "
                                        : ""
                                    }
                                  >
                                    <label htmlFor="productDiscountPrice">
                                      New price
                                      {values.productPrice && (
                                        <ErrorMessage
                                          name="productDiscountPrice"
                                          className="form-input-error"
                                          component="span"
                                        />
                                      )}
                                      {!values.productPrice && (
                                        <span className="price-info-txt">
                                          (Enter original price)
                                        </span>
                                      )}
                                    </label>

                                    <div className="price-wrap">
                                      <span className="currency-pre">$</span>
                                      <Field
                                        value={numberWithCommas(
                                          values.productDiscountPrice,
                                        )}
                                        name="productDiscountPrice"
                                        type="text"
                                        disabled={!values.productPrice}
                                        onChange={(e: any) => {
                                          let valueSet: any = numberWithCommas(
                                            e.target.value,
                                          );
                                          setFieldTouched(
                                            "productDiscountPrice",
                                            true,
                                            true,
                                          );

                                          setFieldValue(
                                            "productDiscountPrice",
                                            valueSet,
                                          );

                                          if (
                                            parseFloat(valueSet) >=
                                            parseFloat(values.productPrice)
                                          ) {
                                            setIsDiscountMore(true);
                                            setFieldValue(
                                              "productDiscountPercent",
                                              "",
                                            );
                                          } else {
                                            setIsDiscountMore(false);
                                            let originalPrice: any = parseFloat(
                                              values.productPrice.replace(
                                                /,/g,
                                                "",
                                              ),
                                            );
                                            valueSet = valueSet.replace(
                                              /,/g,
                                              "",
                                            );

                                            let diff =
                                                parseFloat(originalPrice) -
                                                parseFloat(valueSet),
                                              perCentOffer = Math.round(
                                                (diff /
                                                  parseFloat(originalPrice)) *
                                                  100,
                                              );

                                            setFieldValue(
                                              "productDiscountPercent",
                                              perCentOffer.toString(),
                                            );
                                          }
                                          // setFieldError
                                        }}
                                        // onChange={handleChange}
                                        className={`input-wrap inapp-input ${
                                          errors.productDiscountPrice &&
                                          touched.productDiscountPrice
                                            ? "is-invalid-input "
                                            : !errors.productDiscountPrice &&
                                                values.productDiscountPrice !==
                                                  ""
                                              ? "valid-input"
                                              : ""
                                        }`}
                                      ></Field>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="two-sided">
                                <div className="form-group">
                                  <div
                                    className={
                                      errors.productDiscountStart &&
                                      touched.productDiscountStart
                                        ? "invalid-input-wrap "
                                        : ""
                                    }
                                  >
                                    <label htmlFor="productDiscountStart">
                                      Start date
                                      <ErrorMessage
                                        name="productDiscountStart"
                                        className="form-input-error"
                                        component="span"
                                      />
                                    </label>

                                    <DatePicker
                                      selected={startDate}
                                      onChange={(date: any) => {
                                        onStartChange(date);
                                        setFieldTouched(
                                          "productDiscountStart",
                                          true,
                                        );
                                        setFieldValue(
                                          "productDiscountStart",
                                          date.toISOString(),
                                        );
                                      }}
                                      minDate={new Date()}
                                      name="productDiscountStart"
                                      // maxDate={new Date()}
                                      placeholderText="Select start date"
                                    />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <div
                                    className={
                                      errors.productDiscountEnd &&
                                      touched.productDiscountEnd
                                        ? "invalid-input-wrap "
                                        : ""
                                    }
                                  >
                                    <label htmlFor="productDiscountEnd">
                                      End date
                                      <ErrorMessage
                                        name="productDiscountEnd"
                                        className="form-input-error"
                                        component="span"
                                      />
                                    </label>
                                    <DatePicker
                                      selected={endDate}
                                      onChange={(date: any) => {
                                        onEndChange(date);
                                        setFieldTouched(
                                          "productDiscountEnd",
                                          true,
                                        );
                                        setFieldValue(
                                          "productDiscountEnd",
                                          date.toISOString(),
                                        );
                                      }}
                                      name="productDiscountEnd"
                                      minDate={new Date()}
                                      // maxDate={new Date()}
                                      placeholderText="Select end date"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="product-cta">
                            <button
                              // disabled={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1}
                              disabled={
                                pageProps.createStoreProductRequest
                                  ?.is_request_processing ||
                                allCatsSelected.length < 1 ||
                                selectedImagesStore.length < 1
                              }
                              className={
                                pageProps.createStoreProductRequest
                                  ?.is_request_processing ||
                                allCatsSelected.length < 1 ||
                                selectedImagesStore.length < 1
                                  ? "btn btn-disabled"
                                  : "btn"
                              }
                            >
                              {/* className={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1 ? "btn btn-disabled" : "btn"}> */}
                              {pageProps.createStoreProductRequest
                                .is_request_processing
                                ? "Please wait..."
                                : "Add Product"}
                              {/* {` imgs ${selectedImagesStore.length}`}
                                                {` cats ${selecteCatsStore.length}`} */}
                            </button>
                          </div>
                          {pageProps?.createStoreProductRequest
                            ?.request_status &&
                            pageProps.createStoreProductRequest
                              .request_status === "CREATE_PRODUCT_FAILURE" && (
                              <AlertMsg
                                type="error"
                                message={
                                  pageProps.createStoreProductRequest
                                    ?.request_data.error
                                }
                              />
                            )}
                          {showCatError && (
                            <AlertMsg
                              type="error"
                              message="Select product category"
                            />
                          )}
                        </div>
                        <div className="product-info">
                          <div className="form-group">
                            <div>
                              <label htmlFor="productName">
                                Store name
                                {/* <ErrorMessage name="productName" className="form-input-error" component="span" /> */}
                              </label>
                              {/* <Field
                                                            value={values.productName}
                                                            name="productName"
                                                            id="productName"
                                                            autoComplete="off"
                                                            type="text"
                                                            placeholder="Enter product name here"
                                                            onChange={handleChange}
                                                            className={`input-wrap inapp-input ${errors.productName && touched.productName ?
                                                                "is-invalid-input "
                                                                : !errors.productName && values.productName !== "" ? "valid-input" : ""}`}
                                                        >

                                                        </Field> */}
                              <div className="input-wrap inapp-input store_name_wrap">
                                <div className="store_name">
                                  {state?.storeData.storeName}{" "}
                                  <img src={TickIco} alt="" />{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-group">
                            <div
                              className={
                                errors.productName && touched.productName
                                  ? "invalid-input-wrap"
                                  : ""
                              }
                            >
                              <label htmlFor="productName">
                                Product name
                                <ErrorMessage
                                  name="productName"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <Field
                                value={values.productName}
                                name="productName"
                                id="productName"
                                autoComplete="off"
                                type="text"
                                placeholder="Enter product name here"
                                onChange={handleChange}
                                className={`input-wrap inapp-input ${
                                  errors.productName && touched.productName
                                    ? "is-invalid-input "
                                    : !errors.productName &&
                                        values.productName !== ""
                                      ? "valid-input"
                                      : ""
                                }`}
                              ></Field>
                              <small className="help-text">
                                Maximum of 50 characters
                              </small>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="">
                              {/* <div className={errors.productName && touched.productName ? "invalid-input-wrap" : ""}> */}
                              <label htmlFor="productName">Category</label>
                              <MultiSelect
                                options={allCatsList}
                                value={allCatsSelected}
                                onChange={setAllCatsSelected}
                                labelledBy="Select"
                                hasSelectAll={false}
                                className="cat-select-wrap"
                                // isLoading={true}
                              />
                            </div>
                          </div>
                          <div className="two-sided">
                            <div className="form-group">
                              <div
                                className={
                                  errors.productPrice && touched.productPrice
                                    ? "invalid-input-wrap "
                                    : ""
                                }
                              >
                                <label htmlFor="productPrice">
                                  Price
                                  <ErrorMessage
                                    name="productPrice"
                                    className="form-input-error"
                                    component="span"
                                  />
                                </label>

                                <div className="price-wrap">
                                  <span className="currency-pre">$</span>
                                  <Field
                                    value={numberWithCommas(
                                      values.productPrice,
                                    )}
                                    name="productPrice"
                                    type="text"
                                    placeholder="Product Price"
                                    autoComplete="off"
                                    // onChange={handleChange}
                                    onChange={(e: any) => {
                                      let valueSet: any = numberWithCommas(
                                        e.target.value,
                                      );
                                      setFieldTouched(
                                        "productPrice",
                                        true,
                                        true,
                                      );

                                      setFieldValue("productPrice", valueSet);
                                      if (!e.target.value) {
                                        setFieldValue(
                                          "productDiscountPercent",
                                          "",
                                        );
                                        setFieldValue(
                                          "productDiscountPrice",
                                          "",
                                        );
                                      } else {
                                        if (values.productDiscountPercent) {
                                          let disCountPercentvalue: any =
                                              values.productDiscountPercent.replace(
                                                /,/g,
                                                "",
                                              ),
                                            originalPrice: any = parseFloat(
                                              valueSet.replace(/,/g, ""),
                                            );

                                          if (
                                            parseFloat(disCountPercentvalue) <=
                                            100
                                          ) {
                                            let newProductPrice: any =
                                              (parseFloat(
                                                disCountPercentvalue,
                                              ) /
                                                100) *
                                              originalPrice;
                                            newProductPrice =
                                              originalPrice - newProductPrice;
                                            newProductPrice = Number.parseFloat(
                                              newProductPrice.toString(),
                                            ).toFixed(2);

                                            setFieldValue(
                                              "productDiscountPrice",
                                              newProductPrice,
                                            );
                                          }
                                        }
                                      }
                                    }}
                                    className={`input-wrap inapp-input ${
                                      errors.productPrice &&
                                      touched.productPrice
                                        ? "is-invalid-input "
                                        : !errors.productPrice &&
                                            values.productPrice !== ""
                                          ? "valid-input"
                                          : ""
                                    }`}
                                  ></Field>
                                </div>
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="productSize">
                                Size
                                <ErrorMessage
                                  name="productSize"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <div
                                className={
                                  (errors.productSize && touched.productSize) ||
                                  errors.productUnit
                                    ? "invalid-input qty-input"
                                    : "qty-input"
                                }
                              >
                                <div className="input-item">
                                  <Field
                                    value={numberWithCommas(values.productSize)}
                                    name="productSize"
                                    type="text"
                                    autoComplete="off"
                                    placeholder="Product Size"
                                    onChange={handleChange}
                                    className={` ${
                                      errors.productSize && touched.productSize
                                        ? "is-invalid-input "
                                        : !errors.productSize &&
                                            values.productSize !== ""
                                          ? "valid-input"
                                          : ""
                                    }`}
                                  ></Field>
                                </div>
                                <Field
                                  value={values.productUnit}
                                  name="productUnit"
                                  as="select"
                                  autoComplete="off"
                                  onChange={handleChange}
                                  placeholder=""
                                  className={`${
                                    errors.productUnit && touched.productUnit
                                      ? "is-invalid-input"
                                      : !errors.productUnit &&
                                          values.productUnit !== ""
                                        ? "valid-input"
                                        : ""
                                  }`}
                                >
                                  <option value="">size</option>
                                  {pageProps.getProductMetaDataRequest.request_data.response.units.map(
                                    (eachUnit: any, index: any) => {
                                      return (
                                        <option key={index} value={eachUnit.id}>
                                          {eachUnit.unit}
                                        </option>
                                      );
                                    },
                                  )}
                                </Field>
                              </div>
                            </div>
                          </div>

                          {/* <div className="panel-input">
                                                    <div className="input-title">
                                                        <span>Choose Category</span>
                                                        <img src={CaretDn} alt="" />
                                                    </div>
                                                    <div className="category-lists ">
                                                        {
                                                            pageProps.getProductMetaDataRequest.request_data.response.categories.map((catItem: any, index: any) => {
                                                                return (
                                                                    <div className="each-cat" key={index}>
                                                                        
                                                                        <label className="checkbox-wrap" htmlFor={`${catItem.name}-${catItem.id}`}>
                                                                            <input type="checkbox" id={`${catItem.name}-${catItem.id}`}
                                                                                onChange={(event) => {
                                                                                    let catsTemp = [...selecteCatsStore]


                                                                                    if (catsTemp.indexOf(catItem.name) > -1) {


                                                                                        catsTemp.splice(catsTemp.indexOf(catItem.name), 1)


                                                                                        setSelecteCatsStore(catsTemp)
                                                                                    } else {

                                                                                        catsTemp.push(catItem.name);

                                                                                        setSelecteCatsStore(catsTemp)

                                                                                        setShowCatError(false)
                                                                                    }

                                                                                }}
                                                                            />
                                                                            <span className="checkbox_checkmark"></span>
                                                                        </label>
                                                                        <label htmlFor={`${catItem.name}-${catItem.id}`} >{catItem.name}</label>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div> */}
                          <div className="form-group">
                            <label htmlFor="productQty">
                              Quantity Available
                              <ErrorMessage
                                name="productQty"
                                className="form-input-error"
                                component="span"
                              />
                            </label>
                            <div
                              className={
                                errors.productQty && touched.productQty
                                  ? "invalid-input-wrap"
                                  : ""
                              }
                            >
                              <Field
                                value={allowNumbersOnly(values.productQty)}
                                name="productQty"
                                type="text"
                                autoComplete="off"
                                placeholder="Enter Quantity"
                                onChange={handleChange}
                                className={`input-wrap inapp-input ${
                                  errors.productQty && touched.productQty
                                    ? "is-invalid-input "
                                    : !errors.productQty &&
                                        values.productQty !== ""
                                      ? "valid-input"
                                      : ""
                                }`}
                              ></Field>
                            </div>
                          </div>

                          <div className="form-group">
                            <div>
                              <label htmlFor="productDesc">
                                Description
                                <ErrorMessage
                                  name="productDesc"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <Field name="productDesc">
                                {({ field, form }: any) => (
                                  <ReactQuill
                                    value={field.value}
                                    onChange={(val) =>
                                      form.setFieldValue(field.name, val)
                                    }
                                    onBlur={(_, __, quill) => {
                                      const plainText = quill.getText().trim();
                                      if (plainText.length === 0)
                                        form.setFieldValue(field.name, "");
                                      form.setFieldTouched(field.name, true);
                                    }}
                                    modules={modules}
                                    formats={formats}
                                    className={`custom-quill ${
                                      form.errors.productDesc &&
                                      form.touched.productDesc
                                        ? "is-invalid-input"
                                        : !form.errors.productDesc &&
                                            field.value
                                          ? "valid-input"
                                          : ""
                                    }`}
                                  />
                                )}
                              </Field>
                              <small className="help-text">
                                Maximum of 500 characters
                              </small>
                            </div>
                          </div>

                          <div className="form-group">
                            <div
                              className={
                                errors.productTags && touched.productTags
                                  ? "invalid-input-wrap"
                                  : ""
                              }
                            >
                              <label htmlFor="productTags">
                                Product tags (optional)
                                <ErrorMessage
                                  name="productTags"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <Field
                                value={values.productTags}
                                name="productTags"
                                id="productTags"
                                type="text"
                                autoComplete="off"
                                placeholder="Enter product name here"
                                onChange={handleChange}
                                className={`input-wrap inapp-input ${
                                  errors.productTags && touched.productTags
                                    ? "is-invalid-input "
                                    : !errors.productTags &&
                                        values.productTags !== ""
                                      ? "valid-input"
                                      : ""
                                }`}
                              ></Field>
                              {/* <small className="help-text">Maximum of 50 characters</small> */}
                            </div>
                          </div>

                          {/* Wholesale & Availability */}
                          <div className="form-group thin-bordered-box">
                            <div className="wholesale-available-product-box">
                              <div className="whosale-product-box">
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={wholesaleProduct}
                                      onChange={(e) =>
                                        setWholesaleProduct(e.target.checked)
                                      }
                                      id="wholesaleProduct"
                                    />
                                    This is a wholesale product
                                  </label>
                                </div>

                                <div className="min-order-qty-group">
                                  <input
                                    type="number"
                                    value={minimumOrderQuantity}
                                    onChange={(e) =>
                                      setMinimumOrderQuantity(e.target.value)
                                    }
                                    disabled={!wholesaleProduct}
                                    min={1}
                                    placeholder="Enter minimum order quantity"
                                    className="input-wrap inapp-input"
                                  />
                                </div>
                              </div>
                              <div className="availability-group">
                                <span className="availability-label">
                                  Availability
                                </span>
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <input
                                      type="radio"
                                      name="available"
                                      value="1"
                                      checked={availability === "1"}
                                      onChange={(e) =>
                                        setAvailability(e.target.value)
                                      }
                                    />
                                    Available for Pickup
                                  </label>
                                </div>
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <input
                                      type="radio"
                                      name="available"
                                      value="2"
                                      checked={availability === "2"}
                                      onChange={(e) =>
                                        setAvailability(e.target.value)
                                      }
                                    />
                                    Pre-order
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Variants & Return Eligibility */}
                          <div className="two-shared-box">
                            <div className="form-group thin-bordered-box">
                              <div className="variant-btn-wrapper">
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={addVariant}
                                      onChange={(e) =>
                                        setAddVariant(e.target.checked)
                                      }
                                      id="addVariant"
                                    />
                                    Add/edit variants
                                  </label>
                                </div>
                                <div>
                                  <button
                                    type="button"
                                    className="input-wrap"
                                    disabled={!addVariant}
                                    onClick={() =>
                                      setShowAddEditVariantPopup(true)
                                    }
                                  >
                                    + Add variants option
                                  </button>
                                </div>
                                {addVariant && variants.length > 0 && (
                                  <div className="variant-summary">
                                    {variants.map((variant, index) => (
                                      <div key={index} className="variant-card">
                                        <div className="variant-left">
                                          <div>
                                            <div className="variant-label">
                                              Variance {index + 1}
                                              <button
                                                type="button"
                                                className="variant-edit-btn"
                                                onClick={() => {
                                                  setEditingVariantIndex(index);
                                                  setVariantToEdit(variant);
                                                  setShowAddEditVariantPopup(
                                                    true,
                                                  );
                                                }}
                                                title="Edit variant"
                                              >
                                                ✎
                                              </button>
                                            </div>
                                          </div>
                                          <div className="variant-chip-container">
                                            <div className="variant-chip">
                                              {variant.category}:{" "}
                                              {variant.value}
                                            </div>
                                            <div className="variant-chip">
                                              Price: $
                                              {typeof variant.price === "object"
                                                ? (variant.price as any).amount
                                                : variant.price}
                                            </div>
                                            <div className="variant-chip">
                                              Stock Qty: {variant.stockQuantity}
                                            </div>
                                            {(variant.discountPrice ||
                                              (variant.discountPrice as any)
                                                ?.amount) && (
                                              <div className="variant-chip discount-chip">
                                                Discount: $
                                                {typeof variant.discountPrice ===
                                                "object"
                                                  ? (
                                                      variant.discountPrice as any
                                                    ).amount
                                                  : variant.discountPrice}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="form-group thin-bordered-box">
                              <div className="eligible-btn-wrapper">
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={eligibleForReturn}
                                      onChange={(e) =>
                                        setEligibleForReturn(e.target.checked)
                                      }
                                      id="eligibleForReturn"
                                    />
                                    Eligible for return
                                  </label>
                                </div>

                                <select
                                  className="input-wrap select"
                                  disabled={!eligibleForReturn}
                                  value={eligibleForReturnOption}
                                  onChange={(e) =>
                                    setEligibleForReturnOption(e.target.value)
                                  }
                                >
                                  <option value="0">Select an option</option>
                                  <option value="0">For 3 days.</option>
                                  <option value="1">For 7 days.</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {/* {pageProps?.createStoreProductRequest?.request_status
                                                    && pageProps.createStoreProductRequest.request_status === "CREATE_PRODUCT_FAILURE" &&
                                                    <AlertMsg type="error" message={pageProps.createStoreProductRequest?.request_data.error} />
                                                }
                                                {showCatError &&
                                                    <AlertMsg type="error" message="Select product category" />
                                                } */}
                          {/* {selecteCatsStore.map((item: any) => {
                                                    return <pre>{item}</pre>;
                                                })} */}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
              {showAddEditVariantPopup && (
                <ProductVarianceModal
                  show={showAddEditVariantPopup}
                  onClose={() => {
                    setShowAddEditVariantPopup(false);
                    setEditingVariantIndex(null);
                    setVariantToEdit(null);
                  }}
                  variants={variants}
                  setVariants={setVariants}
                  pageProps={pageProps}
                  sizeOfFetch={sizeofFetch}
                  editIndex={editingVariantIndex}
                  initialEditVariant={variantToEdit}
                />
              )}
            </div>
          )}
        {pageProps.getProductMetaDataRequest.request_status ===
          "GET_PRODUCT_META_PENDING" && <LoadingItem />}
      </div>
    </div>
  );
};
const AddNewProduct = (pageProps: any) => {
  return (
    <InAppTemplate
      pageHeadingTitle="Add New Product"
      showMainPageHeading={true}
      mainPageHeading={<MainHeader />}
      childComponent={<InAppContent pageProps={pageProps} />}
    />
  );
};

const mapDispatchToProps = {
  createProductAction: appActions.CreateStoreProduct,
  getMetadataAction: appActions.GetProductMetaData,
  getImageGalleryAction: appActions.GetImageGallery,
  uploadProductImageAction: appActions.UploadProductImage,
};

const mapStateToProps = (state: any) => ({
  // return {
  // allImagesGallery: ()=>{
  //     return
  // },
  getProductMetaDataRequest: state.allInAppReducers.getProductMetaDataReducer,
  getImageGalleryRequest: state.allInAppReducers.getImageGalleryReducer,
  createStoreProductRequest: state.allInAppReducers.createStoreProductReducer,
  updateProductImageRequest: state.allInAppReducers.updateProductImageReducer,
  uploadProductImageRequest: state.allInAppReducers.uploadProductImageReducer,

  // };
});
export default connect(mapStateToProps, mapDispatchToProps)(AddNewProduct);
